/**
 * Normalizes digital-card API payloads to a consistent shape (aligned with admin portal).
 */
export function normalizeProfileData(raw) {
  if (!raw) return null;

  const cardInfo = Array.isArray(raw.cardInfo) ? raw.cardInfo[0] : raw.cardInfo || {};
  const personalInfo = raw.personalInfo || {};

  const socialMedia =
    raw.socialMedia ||
    raw.data?.socialMedia ||
    raw.data?.socialmedia ||
    {};

  const phoneNumbers = raw.phoneNumbers || raw.data?.phoneNumbers || [];

  const featuredProducts =
    raw.featured_products ||
    raw.data?.featured_products ||
    [];

  return {
    ...raw,
    cardInfo,
    personalInfo,
    socialMedia,
    phoneNumbers,
    data: {
      ...(raw.data || {}),
      socialmedia: socialMedia,
      featured_products: featuredProducts,
      offline_qr: raw.data?.offline_qr ?? raw.offline_qr,
    },
  };
}

export function getSocialMedia(profileData) {
  return (
    profileData?.socialMedia ||
    profileData?.data?.socialmedia ||
    profileData?.data?.socialMedia ||
    {}
  );
}

export function hasSocialLinks(socialMedia) {
  if (!socialMedia || typeof socialMedia !== 'object' || Array.isArray(socialMedia)) {
    return false;
  }
  return Object.values(socialMedia).some(
    (value) => value != null && String(value).trim() !== ''
  );
}

export function getPhoneEntries(profileData) {
  const phones = profileData?.phoneNumbers;
  if (Array.isArray(phones) && phones.length > 0) {
    return phones
      .filter((p) => p?.phone_number && String(p.phone_number).trim() !== '')
      .map((phone, index) => ({
        id: phone.id ?? index,
        label: `Phone ${index + 1}`,
        number: String(phone.phone_number).trim(),
        isPrimary: !!phone.is_primary,
        phoneType: phone.phone_type,
      }));
  }

  const entries = [];
  const primary = profileData?.personalInfo?.user_phone;
  const alt = profileData?.personalInfo?.alt_phone;

  if (primary && String(primary).trim() !== '') {
    entries.push({ id: 'primary', label: 'Phone 1', number: String(primary).trim() });
  }
  if (alt && String(alt).trim() !== '') {
    entries.push({ id: 'alt', label: 'Phone 2', number: String(alt).trim() });
  }

  return entries;
}

export function getFeaturedWebsiteLinks(profileData) {
  const social = getSocialMedia(profileData);
  const website = social.website || profileData?.cardInfo?.website;
  const website2 = social.website2 || profileData?.cardInfo?.website2;

  const links = [];
  if (website) {
    links.push({ url: website, label: 'Visit Our Website' });
  }
  if (website2) {
    links.push({ url: website2, label: 'Visit Our Second Website' });
  }
  return links;
}

export function getMomoNumber(cardInfo = {}) {
  return cardInfo.momo_number_or_code || cardInfo.momo_number || '';
}

export function ensureUrl(url) {
  if (!url) return '';
  const value = String(url).trim();
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  return `https://${value}`;
}

export function formatWhatsAppUrl(value) {
  if (!value) return '';
  const trimmed = String(value).trim();
  if (trimmed.startsWith('http')) return trimmed;
  const cleaned = trimmed.replace(/[^+\d]/g, '');
  return cleaned ? `https://wa.me/${cleaned}` : '';
}
